import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicDirectDebetPocessing({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.6 3.22L6.35.08c.2-.1.45-.1.65 0l5.75 3.14c.61.33.38 1.27-.32 1.27H.93c-.7 0-.94-.94-.33-1.27zm9.18-.08l-3.1-1.7-3.11 1.7h6.2zM6.6 10.45c.28 0 .5.22.5.5v.55a.5.5 0 01-.5.5H.75a.5.5 0 01-.5-.5v-.55c0-.28.22-.5.5-.5H6.6zM3.98 5.29a.5.5 0 00-.5-.5h-.55a.5.5 0 00-.5.5v4.36c0 .28.22.5.5.5h.55a.5.5 0 00.5-.5V5.29zm3-.5c.28 0 .5.22.5.5v2.5a.5.5 0 01-.5.5h-.55a.5.5 0 01-.5-.5v-2.5c0-.28.22-.5.5-.5h.55zm4 .5a.5.5 0 00-.5-.5h-.55a.5.5 0 00-.5.5v1.5c0 .28.22.5.5.5h.55a.5.5 0 00.5-.5v-1.5zM9.76 8.96a3.66 3.66 0 016.21 1.52.7.7 0 01-1.34.37 2.27 2.27 0 00-3.88-.9l1.2 1.2a.2.2 0 01-.13.35H8.5a.2.2 0 01-.2-.2V7.98a.2.2 0 01.34-.14l1.12 1.12zm4.78 5.78a3.66 3.66 0 01-6.21-1.52.7.7 0 011.34-.37 2.27 2.27 0 003.88.9l-1.2-1.2a.2.2 0 01.13-.35h3.32c.11 0 .2.09.2.2v3.32a.2.2 0 01-.34.14l-1.12-1.12z"
      />
    </svg>
  );
}

SvgBasicDirectDebetPocessing.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicDirectDebetPocessing.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicDirectDebetPocessing svgRef={ref} {...props} />
));
export default ForwardRef;
